import { PetitumRevisione } from '../../../models/petitum-revisione';

export class PetitumRevisioneAdapter {

  petitumRevisione: PetitumRevisione = new PetitumRevisione();

  constructor(petitumRevisione: PetitumRevisione) {
    this.petitumRevisione.id = petitumRevisione.id;
    this.petitumRevisione.dataRevisioneDa = petitumRevisione.dataRevisioneDa ? petitumRevisione.dataRevisioneDa : new Date().getTime();
    this.petitumRevisione.dataRevisioneA = petitumRevisione.dataRevisioneA;
    this.petitumRevisione.tipoPetitum = petitumRevisione.tipoPetitum ? JSON.parse(JSON.stringify(petitumRevisione.tipoPetitum)) : null;
    this.petitumRevisione.importoPetitum = petitumRevisione.importoPetitum;
    this.petitumRevisione.interessiPetitum = petitumRevisione.interessiPetitum;
//    this.petitumRevisione.costiGestione = petitumRevisione.costiGestione;
    this.petitumRevisione.compensi = petitumRevisione.compensi;
    this.petitumRevisione.spese = petitumRevisione.spese;
    this.petitumRevisione.rivalutazione = petitumRevisione.rivalutazione;
    this.petitumRevisione.altro = petitumRevisione.altro;
    this.petitumRevisione.gradoRischio = petitumRevisione.gradoRischio ? JSON.parse(JSON.stringify(petitumRevisione.gradoRischio)) : null;
    this.petitumRevisione.percentualeSoccombenza = petitumRevisione.percentualeSoccombenza;
    this.petitumRevisione.accantonamentoPetitum = petitumRevisione.accantonamentoPetitum;
    this.petitumRevisione.accantonamentoInteressi = petitumRevisione.accantonamentoInteressi;
//    this.petitumRevisione.accantonamentoCostiGestione = petitumRevisione.accantonamentoCostiGestione;
    this.petitumRevisione.accantonamentoCompensiSpeseTotale = petitumRevisione.accantonamentoCompensiSpeseTotale;
    this.petitumRevisione.tipoRevisione = petitumRevisione.tipoRevisione ? JSON.parse(JSON.stringify(petitumRevisione.tipoRevisione)) : null;
    this.petitumRevisione.motivoRevisione = petitumRevisione.motivoRevisione;
    this.petitumRevisione.interessiSpeseLegali = petitumRevisione.interessiSpeseLegali;
    this.petitumRevisione.ripartizioneEqua = petitumRevisione.ripartizioneEqua;
    this.petitumRevisione.fondorischiControparti = petitumRevisione.fondorischiControparti ? petitumRevisione.fondorischiControparti : [];
    this.petitumRevisione.importiTotali = petitumRevisione.importiTotali;
    this.petitumRevisione.interesseFR = petitumRevisione.interesseFR;
    this.petitumRevisione.importoFR = petitumRevisione.importoFR;;
    this.petitumRevisione.speseFR = petitumRevisione.speseFR
  }
}


